// 辅助函数 - 处理字符串分割和过滤
export const splitAndFilter = (str, separator = ",") => {
  return str
    .split(separator)
    .map((item) => item.trim())
    .filter(Boolean);
};

import { getModelConfig, fieldTypes } from "./constants";

// 判断字段类型的辅助函数
export const getFieldType = (fieldName, modelName = "purchase.order") => {
  const modelConfig = getModelConfig(modelName);

  // 从模型配置中获取字段类型
  if (modelConfig.fieldTypes && modelConfig.fieldTypes[fieldName]) {
    return modelConfig.fieldTypes[fieldName];
  }

  // 默认返回字符串类型
  return fieldTypes.STRING;
};

// 构建Odoo域表达式
export const buildOdooDomainExpression = (conditionsList) => {
  const conditions = [];

  if (conditionsList.length === 0) {
    conditions.push(["id", "!=", false]);
  } else if (conditionsList.length === 1) {
    conditions.push(conditionsList[0]);
  } else {
    // 添加前缀表示法的AND操作符
    for (let i = 0; i < conditionsList.length - 1; i++) {
      conditions.push("&");
    }
    conditions.push(...conditionsList);
  }

  return JSON.stringify(conditions);
};
